import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  toastWrapper: {
    position: 'fixed',
    zIndex: '1',
    left: '0',
    right: '0',
    bottom: '60px',
    padding: '12px 16px',
    color: theme.new.color.common.white,
    backgroundColor: theme.new.color.textPrimary,
    width: '300px',
    '&.MuiPaper-root': {
      borderRadius: '12px',
      margin: 'auto',
    },
    '& .MuiAccordionDetails-root': {
      padding: '0',
      backgroundColor: theme.new.color.common.white,
      borderRadius: '12px',
    },
    '& .MuiCollapse-wrapper': {
      marginTop: '12px',
    },
    '& .MuiButtonBase-root,& .MuiButtonBase-root.Mui-expanded': {
      minHeight: '28px',
    },
    '& .accordionSummary': {
      color: theme.new.color.common.white,
      padding: '0',
      '& .MuiAccordionSummary-content': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: '0',
      },
    },
    '& .accordionDetails': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      width: '100%',
      height: '48px',
      cursor: 'pointer',
      padding: '13px 16px',
      '&.primary': {
        color: theme.new.color.brandPrimary,
        '&:focus-visible': {
          borderRadius: '12px',
          boxShadow: `0px 0px 0px 2px ${theme.new.color.actionFocus}`,
        },
        '&:hover': {
          color: theme.new.color.actionHover,
        },
      },
      '&.danger': {
        color: theme.new.color.dangerPrimary,
        '&:hover': { color: theme.new.color.dangerSecondary },
        '&:focus-visible': {
          borderRadius: '12px',
          boxShadow: `0px 0px 0px 2px ${theme.new.color.danger[600]}`,
        },
      },
    },
  },
}));

export default useStyles;
